import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ConfigStructure} from '../../../../config/config-structure.model';
import {Property} from '../../../../shared/property/property.model';
import {AppConfigService} from '../../../../config/app-config.service';
import {AppUtils} from '../../../../shared/app-utils';
import {TranslatorService} from '../../../../shared/translator.service';
import {HtmlUtilsService} from '../../../../html-utils/html-utils.service';
import {SortListModel, SortOrderEnum} from '../../../search-list/results/pagination/sort-list/sort-list.model';
import {TranslateService} from '../../../../shared/translate.service';

@Component({
  selector: 'app-materialization-list',
  templateUrl: './materialization-list.component.html',
  styleUrls: ['./materialization-list.component.scss']
})
export class MaterializationListComponent implements OnInit {

  materializations: any[];

  @Output() materializationCount = new EventEmitter<number>();

  onlyDigital: boolean;

  @Input() sortActive: boolean = true;

  allMatProperties: Array<Property[]> = [];

  matProperties: Array<Property[]> = [];

  matConfig: ConfigStructure[];

  pageNumber: number;

  pageCount: number;

  isMobile:boolean = false;

  private pageSize: number;

  showFilters:boolean = false;

  sortFields: SortListModel[] = [
    new SortListModel({field:'mat_pub_date_single', name:this.translate.translate('materialization.mat_pub_date_single'), sortOrder: SortOrderEnum.DESC, isDateType: true,
      isCharType: false}),
    new SortListModel({field:'mat_pub_date_single', name:this.translate.translate('materialization.mat_pub_date_single'), sortOrder: SortOrderEnum.ASC, isDateType: true,
      isCharType: false}),
    new SortListModel({field:'mat_publisher', name:this.translate.translate('materialization.mat_publisher'), sortOrder: SortOrderEnum.ASC, isDateType: false,
      isCharType: true}),
    new SortListModel({field:'mat_publisher', name:this.translate.translate('materialization.mat_publisher'), sortOrder: SortOrderEnum.DESC, isDateType: false,
      isCharType: true})
  ];

  selectedField: SortListModel = this.sortFields[0];

  constructor(private appConfig: AppConfigService, private translator: TranslatorService, public htmlUtils: HtmlUtilsService, private translate: TranslateService) {
  }

  ngOnInit() {
    this.init();
    this.onSelect();
    this.isMobile = this.htmlUtils.mobileVersion;
  }

  getOrderTranslate(sortOrder: SortOrderEnum , isDateType: boolean, isCharType: boolean): string {
    if (isCharType) {
      return this.translate.translate(sortOrder === SortOrderEnum.DESC ? 'SortOrderEnumChar.DESC' : 'SortOrderEnumChar.ASC');
    } else if(isDateType) {
      return this.translate.translate(sortOrder === SortOrderEnum.DESC ? 'SortOrderEnumTime.DESC' : 'SortOrderEnumTime.ASC');
    }
    return this.translate.translate(sortOrder === SortOrderEnum.DESC ? 'SortOrderEnum.DESC' : 'SortOrderEnum.ASC');
  }

  onSelect() {
    if (this.selectedField){
      this.allMatProperties = this.allMatProperties.sort((matA: Property[], matB: Property[]) => {
        let dataA = matA.find(property => property.name==this.selectedField.field);
        let dataB = matB.find(property => property.name==this.selectedField.field);

        dataA = dataA ? dataA.value: 0;
        dataB = dataB ? dataB.value: 0;

        if (Array.isArray(dataA) && dataA.length>0){
          dataA = dataA[0];
        }
        if (Array.isArray(dataB) && dataB.length>0){
          dataB = dataB[0];
        }
        return (dataA+'').localeCompare(dataB+'');
      });
      if (this.selectedField.sortOrder==SortOrderEnum.DESC){
        this.allMatProperties = this.allMatProperties.reverse();
      }
      this.setPage(1);
    }
  }

  @Input('materializations')
  set _materialization(materializations: any){
    this.materializations = materializations;
    this.init();
  }

  getLink(matProp: Property[]): string {
    let property = this.translator.find(matProp, "id");
    return `/materialization/${property.value}`;
  }

  onChange() {
    this.setPage(1);
    this.pageNumber = 1;
  }

  filterDigital(force?: boolean): Array<Property[]> {
    if (this.onlyDigital || force) {
      return this.allMatProperties.filter(value => {
        let property = this.translator.find(value, "mat_digital");
        if (property && property.value === true) {
          return value;
        }
      });
    } else {
      return this.allMatProperties;
    }

  }

  toggleFilter(){
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: string) {
    this.setPage(+page);
  }

  hasNext() {
    return this.pageCount >= this.pageNumber + 1;
  }

  hasPrev() {
    return this.pageNumber - 1 >= 1;
  }

  goToNext() {
    this.pageNumber++;
    this.setPage(this.pageNumber);
  }

  goToPrev() {
    this.pageNumber--;
    this.setPage(this.pageNumber);
  }

  private init() {
    this.allMatProperties = [];
    this.materializations.forEach(value => {
      this.allMatProperties.push(AppUtils.mapObjectToProperties(value));
    });
    this.matConfig = this.appConfig.materializationListConfig;
    this.pageSize = this.appConfig.materializationPerPage;
    this.pageCount = Math.ceil(this.allMatProperties.length / this.pageSize);
    this.pageNumber = 1;
    this.setPage(1);
  }

  private setPropeties(properties: Array<Property[]>) {
    this.matProperties = properties;
    this.materializationCount.emit(this.matProperties.length);
  }

  private setPage(page): void {
    let filterDigital = this.filterDigital();
    if (page > this.pageCount) {
      this.pageNumber = this.pageCount;
      this.setPropeties(filterDigital.slice((this.pageCount - 1) * this.pageSize, this.pageCount * this.pageSize));
    } else if(page < 1) {
      this.pageNumber = 1;
      this.setPage(1);
    }
    else {
      this.setPropeties(filterDigital.slice((page - 1) * this.pageSize, page * this.pageSize));
    }
    this.pageCount = Math.ceil(filterDigital.length / this.pageSize);
  }
}
